import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import AuthLayout from '../components/layout/AuthLayout.jsx';
import { useAuth } from '../contexts/AuthContext.jsx';

export default function RegisterPage() {
  const navigate = useNavigate();
  const { register } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [pin, setPin] = useState('');
  const [confirmPin, setConfirmPin] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setError('');
    if (pin !== confirmPin) return setError('I PIN non corrispondono');
    if (!/^\d{4,6}$/.test(pin)) return setError('Il PIN deve essere 4-6 cifre');
    setLoading(true);
    try {
      await register({ email: email.trim(), password, pin });
      navigate('/dashboard', { replace: true });
    } catch (err) {
      setError(err?.message || 'Registrazione fallita');
    } finally {
      setLoading(false);
    }
  }

  return (
    <AuthLayout
      title="Registrati a MiniCRM"
      subtitle="Crea il tuo account per accedere allo spazio riservato"
      footer={<>Hai già un account?{' '}<Link to="/login" className="text-brand-300 hover:underline">Accedi</Link></>}
    >
      <p className="text-sm text-surface-3">Ottieni un account con mail, password e PIN personale per accesso rapido.</p>
      <form onSubmit={submit} className="space-y-3">
        <div className="flex flex-col gap-1">
          <label className="text-xs text-surface-4" htmlFor="reg-email">Email *</label>
          <input id="reg-email" className="input" type="email" autoComplete="email" autoFocus required value={email} onChange={e => setEmail(e.target.value)} />
        </div>
        <div className="flex flex-col gap-1">
          <label className="text-xs text-surface-4" htmlFor="reg-password">Password (min 6 caratteri) *</label>
          <input id="reg-password" className="input" type="password" autoComplete="new-password" required minLength={6} value={password} onChange={e => setPassword(e.target.value)} />
        </div>
        <div className="flex flex-col gap-1">
          <label className="text-xs text-surface-4" htmlFor="reg-pin">PIN personale (4-6 cifre) *</label>
          <input id="reg-pin" className="input" type="password" inputMode="numeric" autoComplete="off" pattern="[0-9]{4,6}" maxLength={6} required value={pin} onChange={e => setPin(e.target.value)} placeholder="******" />
        </div>
        <div className="flex flex-col gap-1">
          <label className="text-xs text-surface-4" htmlFor="reg-pin-confirm">Conferma PIN *</label>
          <input id="reg-pin-confirm" className="input" type="password" inputMode="numeric" autoComplete="off" maxLength={6} required value={confirmPin} onChange={e => setConfirmPin(e.target.value)} placeholder="******" />
        </div>
        {error && <div className="rounded-md border border-danger/30 bg-danger/10 px-3 py-2 text-xs text-danger">{error}</div>}
        <button type="submit" className="btn btn-primary w-full" disabled={loading}>{loading ? 'Registrazione...' : 'Registrati'}</button>
      </form>
    </AuthLayout>
  );
}